import React from "react";
import { Alert, Box, Button, Chip, Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import {
  changeBatchStatus,
  getBatchesList,
  getCardsData,
  updateStartApproval,
} from "../../redux/features/batchSlice";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import { useSelector } from "react-redux";

export default function CrmStartApproval({
  row,
  disabled,
  dispatchData,
  start,
  open,
  setOpen,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  // const [open, setOpen] = React.useState(false);

  const { loading } = useSelector((state) => state.batch);

  const approvetoStartBatch = () => {
    const payload = {
      isApproved: row?.batch_inactive_approval_status === 0 ? true : false,
      batchID: row.course_batch_id,
    };

    dispatch(updateStartApproval(payload)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        dispatch(getBatchesList(dispatchData));
        dispatch(getCardsData());
      } else {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      }
      setOpen(false);
    });
  };

  return (
    <div>
      <GlobalDialog
        title={"Start Approval"}
        open={open}
        setOpen={setOpen}
        fullWidth
        maxWidth={"xs"}
        content={
          <>
            <Typography>{`Are you sure you want to ${
              row?.batch_inactive_approval_status === 0 ? "approve" : "reject"
            } to start?`}</Typography>
          </>
        }
        actionButton={
          <>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={() => approvetoStartBatch()}
            >
              {loading ? "Loading..." : "Confirm"}
            </Button>
          </>
        }
      />
    </div>
  );
}
